import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import {
  ALLMESSAGES,
  GETAISUMMARYMESSAGES,
  REMOVEAISUMMARYMESSAGE,
} from '../endpoints';

interface MessageType {
  MessageId: number;
  MessageText: string;
  CreatedOn: string;
  SenderName: string;
  RecipientCount: number;
  IsGroup: boolean;
  GroupName: string | null;
  id?: number;
}
interface ODataResponse {
  '@odata.count': number;
  value: MessageType[];
}

export const getSummaryMsgs = async ({
  page,
  size,
  q,
}: {
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(`${baseUrl}${GETAISUMMARYMESSAGES}`, {
    params: {
      page,
      size,
      q,
    },
  });
  return response;
};

export const removeSummaryMessage = async (aiSummaryId: number) => {
  const response = await client.delete(
    `${baseUrl}${REMOVEAISUMMARYMESSAGE}${aiSummaryId}`
  );
  return response;
};

export const getAllMessages = async (query: any) => {
  const response = await client.get<ODataResponse>(
    `${baseUrl}${ALLMESSAGES}${query}`
  );
  return response;
};
